import { useFlexRouter } from '@flexteam/router';
import { UserProfileTabSlug, UserProfileQueryParam } from './types.mjs';

const compactEntries = (entries) => Object.fromEntries(entries.filter(([, value]) => value));
function useUserProfileHref() {
  const { pathname, queryParams } = useFlexRouter();
  const createUserProfileUrlLink = (userIdHash, userName) => {
    return {
      pathname: `/people/user-profile/${userIdHash}/${userName}`
    };
  };
  const getUserProfileHref = (userIdHash, options) => {
    return {
      pathname,
      query: {
        ...queryParams,
        ...compactEntries([
          [UserProfileQueryParam.UserIdHash, userIdHash],
          [UserProfileQueryParam.Tab, options?.tab],
          [
            UserProfileQueryParam.ContractDigiconIdHash,
            options?.contractDigiconIdHash
          ]
        ])
      },
      hash: options?.hash
    };
  };
  const getUserProfileActionState = (userProfileAction) => {
    return {
      custom: {
        action: userProfileAction
      }
    };
  };
  return {
    createUserProfileUrlLink,
    getUserProfileHref,
    getUserProfileActionState,
    UserProfileTabSlug
  };
}

export { useUserProfileHref as default };
//# sourceMappingURL=useUserProfileHref.mjs.map
